import React, { useState, useEffect, createRef } from "react";
import "./Form.css";

// INTERCEPTOR
import { getData } from "../store/FetchNodeServices";
import { api_interceptor } from "../State/Interceptor/interceptor";

// EXTERNAL LIBRARY
import Swal from "sweetalert2";

// COMPONENTS
import { InputComponent } from "../Components/Common/InputComponent";
import { DateInputComponent } from "../Components/Common/DateInputComponent";
import { TextAreaInputComponent } from "../Components/Common/TextAreaInputComponent";
import { ImageInputComponent } from "../Components/Common/ImageInputComponent";
import { DropDownInputComponent } from "../Components/Common/DropdownInputComponent";
import { DataPreviewComponent } from "../Components/DataPreviewComponent";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LogoutAction } from "../State/Action/auth";


export default function Form() {
  const location = useLocation();
   const navigate = useNavigate();
  const dispatch = useDispatch();

  const [Name, setName] = useState("");
  const [DOB, setDOB] = useState("");
  const [Spouse, setSpouse] = useState("");
  const [SpouseDob, setSpouseDob] = useState("");
  const [AnniversaryAt, setAnniversaryAt] = useState("");
  const [Children, setChildren] = useState("");
  const [Photo, setPhoto] = useState();
  const [FamilyPhoto, setFamilyPhoto] = useState();
  const [occupation, setOccupation] = useState("");
  const [customOccupation, setCustomOccupation] = useState("");
  const [BusinessWebLink, setBusinessWebLink] = useState("");
  const [HomeAddress, setHomeAddress] = useState("");
  const [PrimaryContact, setPrimaryContact] = useState("");
  const [SecondaryContact, setSecondaryContact] = useState("");
  const [EmailID, setEmailID] = useState("");
  const [OfficeAddress, setOfficeAddress] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zone, setZone] = useState("");
  const currDate = React.useMemo(() => Date.now(), []);

  const [profileLoading, setprofileLoading] = useState(false);
  const [profileEdit, setprofileEdit] = useState(false);

  const [businessData, setbusinessData] = useState([
    {
      type: "",
      bname: "",
      description: "",
      id: currDate,
      other: "",
    },
  ]);

  const [loading, setloading] = useState(false);

  const [modalState, setmodalState] = useState(false);

  // DATA AVAILABLE
  const [availableZones, setavailableZones] = useState([]);
  const [availableStates, setavailableStates] = useState([]);
  const [availableCities, setAvailableCities] = useState([]);
  const [availableBusinessNames, setavailableBusinessNames] = useState([]);
  
  const fetchAllState = async () => {
    var result = await getData("state");
    setavailableStates(result.data);
  };

  const fetchAllCities = async () => {
    var result = await getData("city");
    setAvailableCities(result.data);
  };

  const fetchAllZone = async () => {
    var result = await getData("zone");
    setavailableZones(result.data);
  };

  const fetchAllBusiness = async () => {
    var result = await getData("business");
    setavailableBusinessNames(result.data);
  };

  useEffect(function () {
    fetchAllState();
    fetchAllCities();
    fetchAllZone();
    fetchAllBusiness();
  }, []);

  useEffect(() => {
    if (location.pathname === "/profile") {
      setprofileEdit(true);
      setprofileLoading(false);
      api_interceptor
        .get("/details")
        .then((res) => {
          if (res.status) {
            const {
              Name,
              Emailid,
              Businessweblink,
              Children,
              City,
              State,
              Spouse,
              Homeaddress,
              Occupation,
              Zone,
              SpouseDob,
              DOB,
              AnniversaryAt,
              PrimaryContact,
              SecondaryContact,
              Photo,
              FamilyPhoto,
              Officeaddress,
              BType1,
              Business1,
              BDescription1,
              BType2,
              Business2,
              BDescription2,
              BType3,
              Business3,
              BDescription3,
              BType4,
              Business4,
              BDescription4,
              BType5,
              Business5,
              BDescription5,
            } = res.data.data;

            let _b = [];

            if (BType1) {
              const _f = availableBusinessNames.find(
                (item) => item.Name === BType1
              );
              _b.push({
                type: _f ? BType1 : "Others",
                bname: Business1,
                description: BDescription1,
                id: "1",
                other: _f ? "" : BType1,
              });
            }

            if (BType2) {
              const _f = availableBusinessNames.find(
                (item) => item.Name === BType2
              );
              _b.push({
                type: _f ? BType2 : "Others",
                bname: Business2,
                description: BDescription2,
                id: "2",
                other: _f ? "" : BType2,
              });
            }
            if (BType3) {
              const _f = availableBusinessNames.find(
                (item) => item.Name === BType3
              );
              _b.push({
                type: _f ? BType3 : "Others",
                bname: Business3,
                description: BDescription3,
                id: "3",
                other: _f ? "" : BType3,
              });
            }
            if (BType4) {
              const _f = availableBusinessNames.find(
                (item) => item.Name === BType4
              );
              _b.push({
                type: _f ? BType4 : "Others",
                bname: Business4,
                description: BDescription4,
                id: "4",
                other: _f ? "" : BType4,
              });
            }
            if (BType5) {
              const _f = availableBusinessNames.find(
                (item) => item.Name === BType5
              );
              _b.push({
                type: _f ? BType5 : "Others",
                bname: Business5,
                description: BDescription5,
                id: "5",
                other: _f ? "" : BType5,
              });
            }

            setbusinessData(_b);

            setName(Name);
            setEmailID(Emailid);
            setBusinessWebLink(Businessweblink);
            setChildren(Children);
            setCity(City);
            setState(State);
            setSpouse(Spouse);
            setHomeAddress(Homeaddress);
            if (Occupation === "Job" || Occupation === "Business") {
                setOccupation(Occupation);
              } else if (Occupation) {
                setOccupation("Others");
                setCustomOccupation(Occupation);
              }
            setZone(Zone);
            setDOB(DOB);
            setAnniversaryAt(AnniversaryAt);
            setSpouseDob(SpouseDob);
            setOfficeAddress(Officeaddress);

            setPrimaryContact(PrimaryContact);
            setSecondaryContact(SecondaryContact);

            setPhoto(Photo || "not-found.jpg");
            setFamilyPhoto(FamilyPhoto || "not-found.jpg");
          } else {
            setprofileEdit(false);
            alert(res.data.message);
          }
        })
        .catch(() => {
          setprofileEdit(false);
          alert("Something went wrong");
        })
        .finally(() => {
          setprofileLoading(false);
        });
    } else {
      setprofileEdit(false);
    }
    return () => {};
  }, [location.pathname, availableBusinessNames]);

  const handlePhoto = (event) => {
    setPhoto({ filename: URL.createObjectURL(event.target.files[0]), bytes: event.target.files[0] });
  };

  const handleFamilyPhoto = (event) => {
    setFamilyPhoto({ filename: URL.createObjectURL(event.target.files[0]), bytes: event.target.files[0] });
  };

  const emptyValue = () => {
    setName("");
    setDOB("");
    setSpouse("");
    setSpouseDob("");
    setAnniversaryAt("");
    setChildren("");
    setPhoto("");
    setFamilyPhoto("");
    setOccupation("");
    setBusinessWebLink("");
    setHomeAddress("");
    setPrimaryContact("");
    setSecondaryContact("");
    setEmailID("");
    setOfficeAddress("");
    setState("");
    setCity("");
    setZone("");

    setbusinessData([
      {
        type: "",
        bname: "",
        description: "",
        id: Date.now(),
        other: "",
      },
    ]);
  };

  const handleSubmit = async () => {
    console.log("Submit Photo :", Photo)
    console.log("Submit FamilyPhoto :", FamilyPhoto)
    setloading(true);
    const formData = new FormData();

    formData.append("Name", Name);
    formData.append("DOB", DOB);
    formData.append("Spouse", Spouse);
    formData.append("SpouseDob", SpouseDob);
    formData.append("AnniversaryAt", AnniversaryAt);
    formData.append("Children", Children);
    formData.append("Photo", Photo?.bytes || Photo);
    formData.append("FamilyPhoto", FamilyPhoto?.bytes || FamilyPhoto);
    formData.append("Occupation", occupation === "Others" ? customOccupation : occupation);
    formData.append("BusinessWebLink", BusinessWebLink);
    formData.append("HomeAddress", HomeAddress);
    formData.append("PrimaryContact", PrimaryContact);
    formData.append("SecondaryContact", SecondaryContact);
    formData.append("EmailID", EmailID);
    formData.append("OfficeAddress", OfficeAddress);
    formData.append("state", state);
    formData.append("city", city);
    formData.append("zone", zone);
    formData.append(
      "business",
      JSON.stringify(
      businessData.length > 0 && businessData[0]?.bname? businessData : [])
    );

    api_interceptor
      .post(`details/${profileEdit ? "update" : "add"}`, formData)
      .then((res) => {
        if (res.data.result) {
          if (!profileEdit) {
            Swal.fire({
              title: "Data Submitted Successfully!",
              icon: "success",
            });
            emptyValue();
          } else {
            Swal.fire({
              title: "Data Updated Successfully!",
              icon: "success",
            });
          }
        } else {
          Swal.fire({
            title: "Data not submitted",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        console.log('ERROR IS : ',err)
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
        });
      })
      .finally(() => setloading(false));
  };


  const handleAdd = () => {
    setbusinessData((dt) => [
      ...dt,
      {
        type: "",
        bname: "",
        description: "",
        id: Date.now(),
        other: "",
      },
    ]);
  };

  const handleRemove = (key) => {
    const list = [...businessData];
    list.splice(key, 1);
    setbusinessData(list);
  };

  return (
    <div>
      <DataPreviewComponent
        action={handleSubmit}
        aniversaryAt={AnniversaryAt}
        business={businessData}
        businessWebLink={BusinessWebLink}
        changeModalState={setmodalState}
        modalState={modalState}
        state={state}
        children={Children}
        city={city}
        dob={DOB}
        emailId={EmailID}
        familyPhoto={FamilyPhoto?.filename || FamilyPhoto}
        homeAddress={HomeAddress}
        name={Name}
        occupation={occupation+' '+customOccupation}
        officeAddress={OfficeAddress}
        photo={Photo?.filename || Photo}
        primaryContact={PrimaryContact}
        secondaryContact={SecondaryContact}
        spouse={Spouse}
        spouseDob={SpouseDob}
        zone={zone}
      />
      <div className="w-[90%] md:w-[70%] mx-auto">
        <nav className="grid grid-cols-5 gap-4 my-4 p-3 bg-white rounded-md">
          <img src="/images/logo.png" className="w-[80%] self-center" alt="." />
          <div className="col-span-3 text-center text-black font-semibold text-2xl sm:text-3xl py-3 sm:py-5">
            <p>{!profileEdit ? "Add Your Profile" : "Edit Your Profile"}</p>
          </div>
          <img
            src="/images/smalogo.png"
            className="w-full self-center"
            alt="."
          />
        </nav>
        {!profileEdit && <button
              onClick={() => {
                navigate('/directory')
              }}
              className="bg-[#5c33ae] hover:bg-[#2f0e70] text-white px-4 py-2 transition-all duration-300 rounded-md mb-4"
            >
              Home
        </button>}
        {profileEdit ? (
          <div className="flex justify-between mb-4">
            <button
              onClick={() => {
                navigate('/directory')
              }}
              className="bg-[#5c33ae] hover:bg-[#2f0e70] text-white px-4 py-2 transition-all duration-300 rounded-md"
            >
              Home
            </button>
            <button
              onClick={() => {
                dispatch(LogoutAction());
              }}
              className="bg-[#5c33ae] hover:bg-[#2f0e70] text-white px-4 py-2 transition-all duration-300 rounded-md"
            >
              Logout
            </button>
          </div>
        ) : (
          <></>
        )}

        {profileLoading ? (
          <p>Loading...</p>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setmodalState(true);
            }}
          >
            <InputComponent
              id={"name"}
              name={"Full Name"}
              value={Name}
              changeValue={setName}
              required={true}
            />

            <InputComponent
              id={"contact"}
              name={"Contact Number"}
              value={PrimaryContact}
              required={true}
              changeValue={setPrimaryContact}
              type="tel"
              min={10}
              max={10}
            />            

            <DropDownInputComponent
              id={"zone"}
              data={availableZones}
              name={"Zone"}
              selectBy={"Name"}
              changeValue={setZone}
              required={true}
              value={zone}
            />

            <TextAreaInputComponent
              value={HomeAddress}
              changeValue={setHomeAddress}
              id={"homeaddress"}
              name={"Address"}
            />

            <DropDownInputComponent
              id={"state"}
              data={availableStates}
              name={"State"}
              selectBy={"StateName"}
              changeValue={setState}
              value={state}
              required={true}
            />

            <InputComponent
              id={"city"}
              name={"City"}
              value={city}
              changeValue={setCity}
              required={true}
            />
            <ImageInputComponent
              value={Photo}
              changeValue={handlePhoto}
              id={"photo"}
              required={!profileEdit}
              name={"Photo"}
              subName={"to be used as profile picture"}
            />
            
            <ImageInputComponent
              value={FamilyPhoto}
              changeValue={handleFamilyPhoto}
              id={"familyphoto"}
              name={"Family Photo"}
              subName={"to be used as cover picture"}                
            />

            
            <DateInputComponent
              id={"dob"}
              name={"D.O.B"}
              value={DOB}
              changeValue={setDOB}
            />

            <InputComponent
              id={"email"}
              name={"Email"}
              value={EmailID}
              changeValue={setEmailID}
              type="email"
            />

            <div className="bg-white px-10 sm:px-20 py-5 sm:py-10 rounded-xl border-l-4 border-[#5d5df1] mb-3">
              <div className="businessmaindiv">
                <div>
                  <div className="lg:flex lg:justify-between mb-5">
                    <div className="lg:w-3/6">
                      <label className="font-medium">Occupation</label>
                      <select
                        value={occupation}
                        onChange={(e) => {
                          setOccupation(e.target.value);
                          // Reset custom occupation when switching away from "Others"
                          if (e.target.value !== "Others") {
                            setCustomOccupation("");
                          }
                        }}
                        className="border-[1px] px-3 py-2 rounded-md border-gray-300 mt-2 outline-none transition-all duration-300 focus:border-[#1976D2] focus:border-b-2 w-full"
                      >
                        <option value="">--Please Select--</option>
                        <option value="Job">Job</option>
                        <option value="Business">Business</option>
                        <option value="Others">Others (Please Specify)</option>
                      </select>
                    </div>

                    {occupation === "Others" && (
                      <div className="lg:w-2/5 mt-3 lg:mt-0">
                        <div className="flex flex-col justify-between">
                          <label className="font-medium">Please Specify</label>
                          <input
                            className="border-[1px] px-3 py-2 rounded-md border-gray-300 mt-2 outline-none transition-all duration-300 focus:border-[#1976D2] focus:border-b-2"
                            type="text"
                            placeholder="Please Specify"
                            value={customOccupation}
                            onChange={(e) => {
                              setCustomOccupation(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>


            <div className="bg-white px-10 sm:px-20 py-5 sm:py-10 rounded-xl border-l-4 border-[#5d5df1] mb-3">
              {businessData.map((item, key) => {
                return (
                  <div key={key} className="businessmaindiv">
                    <div>
                      <div className="lg:flex lg:justify-between mb-5">
                        <div className="lg:w-3/6">
                          <label className="font-medium">Business Type<span className="text-red-500"> *</span></label>
                          <select
                            onChange={(event) => {
                              let dt = [...businessData];
                              dt[key].type = event.target.value;
                              dt[key].other = "";

                              setbusinessData(dt);
                            }}
                            required={true}
                            value={item.type}
                            className="border-[1px] px-3 py-2 rounded-md border-gray-300 mt-2 outline-none transition-all duration-300 focus:border-[#1976D2] focus:border-b-2 w-full "
                          >
                            <option value={""}>--Please Select--</option>
                            {availableBusinessNames.map((item, index) => {
                              return (
                                <option key={index} value={item.Name}>
                                  {item.Name}
                                </option>
                              );
                            })}
                            <option value={"Others"}>
                              Others (Please Specify)
                            </option>
                          </select>
                        </div>

                        <div className="lg:w-2/5 mt-3 lg:mt-0">
                          {item.type === "Others" && (
                            <div className="flex flex-col justify-between">
                              <label
                                className="font-medium"
                                htmlFor={`BusinessType${key}`}
                              >
                                Please Specify
                              </label>
                              <input
                                className="border-[1px] px-3 py-2 rounded-md border-gray-300 mt-2 outline-none transition-all duration-300 focus:border-[#1976D2] focus:border-b-2"
                                type="text"
                                id={`BusinessType${key}`}
                                value={item.other}
                                placeholder="Please Specify"
                                onChange={(event) => {
                                  let dt = [...businessData];
                                  dt[key].other = event.target.value;
                                  setbusinessData(dt);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-7">
                        <label
                          className="font-medium block"
                          htmlFor={`bname${key}`}
                        >
                          Business Name {key >= 1 ? key + 1 : ""}
                        </label>
                        <input
                          className="outline-none border-b border-gray-500 w-4/5 sm:w-3/5 mt-4 transition-all duration-300 focus:border-[#1976D2] focus:border-b-2"
                          type="text"
                          id={`bdescription${key}`}
                          value={item.bname}
                          onChange={(event) => {
                            let dt = [...businessData];
                            dt[key].bname = event.target.value;
                            setbusinessData(dt);
                          }}
                        />
                      </div>
                    </div>

                    <div>
                      <label
                        className="font-medium block"
                        htmlFor={`bdescription${key}`}
                      >
                        Business Description {key >= 1 ? key + 1 : ""}
                      </label>
                      <input
                        className="outline-none border-b border-gray-500 w-4/5 sm:w-3/5 mt-4 transition-all duration-300 focus:border-[#1976D2] focus:border-b-2"
                        type="text"
                        id={`bdescription${key}`}
                        value={item.description}
                        onChange={(event) => {
                          let dt = [...businessData];
                          dt[key].description = event.target.value;
                          setbusinessData(dt);
                        }}
                      />
                    </div>

                    {businessData.length !== 1 && (
                      <div className="my-5 flex justify-end">
                        <button
                          className="bg-[#5c33ae] px-10 py-2 text-white rounded-lg hover:bg-[#2f0e70]"
                          type="button"
                          onClick={() => handleRemove(key)}
                        >
                          Remove
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}

              {businessData.length !== 5 && (
                <div className="mt-5 flex justify-end">
                  <div>
                  <p className="text-gray-600">Add more Businesses, if any</p>
                  <button
                    className="bg-[#5c33ae] px-10 py-2 text-white rounded-lg hover:bg-[#2f0e70]"
                    type="button"
                    onClick={handleAdd}
                  >
                    Add
                  </button>
                  </div>
                </div>
              )}
            </div>

            {loading ? (
              <div className="spinner"></div>
            ) : (
              <div className="my-5 pl-3">
                <button
                  className="bg-[#5c33ae] hover:bg-[#2f0e70] px-10 py-2 text-white rounded-lg "
                  type="submit"
                >
                  Preview
                </button>
              </div>
            )}
          </form>
        )}
      </div>
      <footer className="mt-4 p-4 bg-gray-800 text-gray-200">
        <p className="text-center">Powered by Globe13 Digital Pvt. Ltd.</p>
      </footer>
    </div>
  );
}
